import { render } from "./PayMediaEditForm.vue?vue&type=template&id=5336bb76&scoped=true"
import script from "./PayMediaEditForm.vue?vue&type=script&lang=js"
export * from "./PayMediaEditForm.vue?vue&type=script&lang=js"

import "./PayMediaEditForm.vue?vue&type=style&index=0&id=5336bb76&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5336bb76"]])

export default __exports__